import { Home } from "./components/Home";
import { Tickers } from "./components/Tickers";
import { Candles } from "./components/Candles";
import { Charts } from "./components/Charts";
import { Packages } from "./components/Packages";
import { SimulationReports } from "./components/SimulationReports";
import { SimulationReportChartView } from "./components/SimulationReportChartView";
import { DecisionMakerTuning } from "./components/DecisionMakerTuning";
import { Models } from "./components/Models";
import { ModelsWithRecentSignals } from "./components/ModelsWithRecentSignals";
import { ModelExecution } from "./components/ModelExecution";
import { ModelSpreadsheet } from "./components/ModelSpreadsheet";
import { SharedSpreadsheets } from "./components/SharedSpreadsheets";
import { Login } from "./components/Login";
import { SignUp } from "./components/SignUp";
import { Notifications } from "./components/Notifications";
import { NotificationPreferences } from "./components/NotificationPreferences";
import { Profile } from "./components/Profile";
import { ChangePassword } from "./components/ChangePassword";
import { Admin } from "./components/admin/Admin";
import { SignalFiles } from "./components/SignalFiles";
import { CombineModels } from "./components/CombineModels";
import { SignalsOverlay } from "./components/SignalsOverlay";
import { Help } from "./components/Help";
import { PerformanceCalculation } from "./components/PerformanceCalculation";
import { PerformanceCalculationSettings } from "./components/PerformanceCalculationSettings";
import { TradingConnectors } from "./components/TradingConnectors";
import { TradingStrategies } from "./components/TradingStrategies";
import { TradingStrategyEdit } from "./components/TradingStrategyEdit";
import { TradingStrategyView } from "./components/TradingStrategyView";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/help',
    element: <Help />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/signup',
    element: <SignUp />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/notifications',
    element: <Notifications />
  },
  {
    path: '/notifications/preferences',
    element: <NotificationPreferences />
  },
  {
    path: '/profile/change-password',
    element: <ChangePassword />
  },
  {
    path: '/admin/*',
    element: <Admin />
  },
  {
    path: '/tickers',
    element: <Tickers />
  },
  {
    path: '/candles',
    element: <Candles />
  },
  {
    path: '/candles/ticker/:tickerId',
    element: <Candles />
  },
  {
    path: '/charts',
    element: <Charts />
  },
  {
    path: '/packages',
    element: <Packages />
  },
  {
    path: '/simulation-reports',
    element: <SimulationReports />
  },
  {
    path: '/simulation-reports/:id/chart-data',
    element: <SimulationReportChartView />
  },
  {
    path: '/dm-tuning',
    element: <DecisionMakerTuning />
  },
  {
    path: '/models',
    element: <Models />
  },
  {
    path: '/models-with-recent-signals',
    element: <ModelsWithRecentSignals />
  },
  {
    path: '/model-execution',
    element: <ModelExecution />
  },
  {
    path: '/model-spreadsheet',
    element: <ModelSpreadsheet />
  },
  {
    path: '/shared-spreadsheets',
    element: <SharedSpreadsheets />
  },
  {
    path: '/signal-files',
    element: <SignalFiles />
  },
  {
    path: '/combine-models',
    element: <CombineModels />
  },
  {
    path: '/signals-overlay',
    element: <SignalsOverlay />
  },
  {
    path: '/performance-calculation',
    element: <PerformanceCalculation />
  },
  {
    path: '/performance-calculation/settings',
    element: <PerformanceCalculationSettings />
  },
  {
    path: '/trading-connectors',
    element: <TradingConnectors />
  },
  {
    path: '/trading-strategies',
    element: <TradingStrategies />
  },
  {
    path: '/trading-strategies/new',
    element: <TradingStrategyEdit />
  },
  {
    path: '/trading-strategies/:id/edit',
    element: <TradingStrategyEdit />
  },
  {
    path: '/trading-strategies/:id/view',
    element: <TradingStrategyView />
  },
  {
    path: '/trading-strategies/:id/view/review-pending-trade',
    element: <TradingStrategyView reviewPendingTrade />
  }
];

export default AppRoutes;
